import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WithdrawalReverseComponent } from './withdrawal-reverse.component';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { DateTimestampFormatPipe } from 'src/app/pipes/date-timestamp-format.pipe';



@NgModule({
  declarations: [
    WithdrawalReverseComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule,
    DateTimestampFormatPipe
  ]
})
export class WithdrawalReverseModule { }
